import React from 'react'
import { faRupeeSign, faStar, faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageSkeleton, LineSkeleton } from '../../Skeletons/skeletonTemplates';

export default function InstructorComponent(props) {
    if (props.data && !props.data.all_instructors.length)
        return <div />
    
    function getBatches(batchList) {
        var res = ""
        for (var i = 0; i < batchList.length - 1; i++)
            res += batchList[i] + " | ";
        if (batchList.length)
            res += batchList[batchList.length - 1];
        return res;
    }

    function showRating(rating) {
       return Number(rating) && props.showMentorRating ? <>
       <span className ="divider"></span>
        <FontAwesomeIcon icon = {faStar} className="starIconFeed"/>
        <span>
        {rating}
        </span>
       </> : null
    }
    
    var instructors;
    if (!props.data) {
        instructors = [
            <div className = "row mt-5">
                <div className = "col-md-3 mb-4">
                    <ImageSkeleton classes = "rounded-circle icon-size" />
                    <div className = "row"></div>
                </div>
                <div className = "col-11 mx-auto col-md-9 pl-0 pr-0">
                    <div className = "">
                        {LineSkeleton(8)}
                    </div>
                </div>
            </div>
        ] 
    } else {
        instructors = props.data.all_instructors.map((mentor, index) =>
            <div className = "row mt-5">
                <div className = "col-md-3">
                    <img className = "img-fluid col-12 rounded-circle instructor_component_image" src = {mentor.profile_image}></img>
                    <div className = "row"></div>
                </div>
                <div className = "col-11 mx-auto col-md-9 pl-0 pr-0">
                    <div className = "row my-auto pb-0 pt-0">
                        <h4 className = "col-9 font-weight-bold d-sm-block d-none text-dark text-left mb-0 pb-0 mentor-name">
                            {mentor.mentor}
                            {showRating(mentor.mentor_rating)}
                        </h4>
                        <h4 className = "col-12 font-weight-bold d-sm-none d-block text-dark mx-auto mt-2 mb-0">
                            {mentor.mentor}
                            {showRating(mentor.mentor_rating)}
                        </h4>
                        {(mentor.linkedin_profile && mentor.linkedin_profile.length > 0) && 
                            <a target = "_blank" className = "col-2 d-sm-block d-none text-secondary text-left" href = {mentor.linkedin_profile}>
                                <img className = "img-fluid linkedin-icon" src = "https://media.geeksforgeeks.org/img-practice/Group4604-1618397340.svg"/>
                            </a>
                        }
                        {props.data.canEditMentors &&
                            <a type = "button" href = {mentor.edit_link}><FontAwesomeIcon icon = {faEdit} /></a>
                        }
                    </div>
                    <div className = "font-weight-bold d-sm-block d-none text-secondary mb-2 text-left mentor-bio" dangerouslySetInnerHTML={{ __html: mentor.mentor_bio }}></div>
                    <div className = "font-weight-bold d-sm-none d-block text-secondary mb-3 text-center" dangerouslySetInnerHTML={{ __html: mentor.mentor_bio }}></div>
                    <div className = "text-muted d-sm-block d-none col-md-9 pl-0 text-left mentor-description" dangerouslySetInnerHTML={{ __html: mentor.mentor_description }}></div>
                    <div className = "text-muted d-sm-none d-block col-md-9 pl-0 pr-0 text-center mentor-description" dangerouslySetInnerHTML={{ __html: mentor.mentor_description }}></div>
                    {index === 0 && props.demoVideo &&<p className='demo-video' data-toggle="modal" 
                     data-target="#videoModal" onClick = {() => {
                        props.playVideo(props.demoVideo)
                    }} >Demo Video</p>}
                    {(mentor.associated_batch_names && mentor.associated_batch_names.length > 0) && 
                        <div>   
                            <div className = "text-muted d-sm-block d-none col-md-9 pl-0 text-left">
                                <h6 className = "font-weight-bold">Associated Batches :</h6>
                                {getBatches(mentor.associated_batch_names)}
                            </div>
                            <div className = "text-muted d-sm-none d-block col-md-9 pl-0 pr-0 text-center">
                                <h6 className = "font-weight-bold">Associated Batches :</h6>
                                {getBatches(mentor.associated_batch_names)}
                            </div>
                        </div>
                    }    
                </div>
                <a target = "_blank" className = "col-2 d-sm-none d-block text-secondary mx-auto" href = {mentor.linkedin_profile}><img className = "img-fluid" src = "https://media.geeksforgeeks.org/img-practice/Group4604-1618397340.svg"/></a>
            </div>
        );
    }

    return (
        <section className = "instructor-component">
            <div className = "jumbotron">
                <div className = "col-md-10 mx-auto">
                    <div className = "row">
                        <h1 className = "text-success col-12 pl-0 pr-0 col-md-6 font-weight-bold mx-auto mb-3">Course Instructor</h1>
                    </div>
                        {instructors}
                </div>
            </div>
        </section>
    )
}